<template>
  <a
    ref="signinGoogleBtn"
    rel="nofollow"
    class="btn btn--google"
    @click.prevent
  >
    <span class="authbox__social-icon authbox__social-icon--big">
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M8.86484 24.173L7.4725 29.3709L2.38352 29.4785C0.862656 26.6577 0 23.4302 0 20.0005C0 16.6841 0.806563 13.5566 2.23625 10.8027H2.23734L6.76797 11.6334L8.75266 16.1368C8.33726 17.3478 8.11086 18.6478 8.11086 20.0005C8.11101 21.4687 8.37695 22.8753 8.86484 24.173Z"
            fill="#FBBB00"
          ></path>
          <path
            d="M39.6508 16.2637C39.8805 17.4735 40.0003 18.723 40.0003 19.9999C40.0003 21.4318 39.8497 22.8285 39.5629 24.1758C38.5893 28.7604 36.0453 32.7637 32.5212 35.5966L32.5201 35.5955L26.8135 35.3044L26.0059 30.2626C28.3443 28.8912 30.1718 26.745 31.1345 24.1758H20.4399V16.2637H31.2905H39.6508Z"
            fill="#518EF8"
          ></path>
          <path
            d="M32.52 35.5969L32.5211 35.598C29.0937 38.3529 24.7398 40.0013 20.0003 40.0013C12.3838 40.0013 5.76184 35.7441 2.38379 29.4793L8.86512 24.1738C10.5541 28.6815 14.9025 31.8903 20.0003 31.8903C22.1914 31.8903 24.2443 31.298 26.0057 30.2639L32.52 35.5969Z"
            fill="#28B446"
          ></path>
          <path
            d="M32.766 4.60437L26.2869 9.90875C24.4638 8.76922 22.3088 8.11094 20.0001 8.11094C14.7869 8.11094 10.3572 11.467 8.75281 16.1362L2.23742 10.8022H2.23633C5.56492 4.38461 12.2704 0 20.0001 0C24.8528 0 29.3023 1.72859 32.766 4.60437Z"
            fill="#F14336"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="40" height="40" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    </span>
    Google
  </a>
</template>

<script>
import signable from '~/mixins/signable'
import loadScript from '~/utils/loadScript'

export default {
  name: 'GoogleLogin',
  mixins: [signable],
  async mounted() {
    await loadScript('https://apis.google.com/js/api:client.js')
    await this.initGoogle()
  },
  methods: {
    initGoogle() {
      window.gapi.load('auth2', () => {
        const auth2 = window.gapi.auth2.init({
          clientId: this.$config.brGoogleId,
        })

        auth2.attachClickHandler(
          this.$refs.signinGoogleBtn,
          {
            scope: 'email profile',
          },
          async (googleCtx) => {
            try {
              const BasicProfile = googleCtx.getBasicProfile()

              const user = await this.$axios.$post(
                'auth/facebook' + '?uid=' + BasicProfile.getId(),
                {
                  auth_info: {
                    email: BasicProfile.getEmail(),
                  },
                }
              )

              if (user?.code === 2) {
                this.$store.dispatch('omniauthRegister/updateSocialUserInfo', {
                  firstname: BasicProfile.getGivenName(),
                  lastname: BasicProfile.getFamilyName(),
                  email: BasicProfile.getEmail(),
                })
                this.$router.push('/signup')
              } else {
                this.$sentry.setUser(user || {})
                this.emitSuccess()
                location.reload()
              }
            } catch (err) {
              this.handleError(err)
            }
          },
          (err) => {
            this.handleError(err)
          }
        )
      })
    },
  },
}
</script>

<style></style>
